<template>
    <div class="admin_parent">
        <div class="clearfix admin_nav">
            <div class="navig_logo fl">
                <img src="./../../assets/img/logo.png" alt="">
            </div>
            <div class="fr navig_div">
                <div class="navig_title">
                    <h3 class="fl">评审端 ---- {{this.$store.state.schName}}</h3>
                    <span class="fr" @click="exit()">
                        <el-button type="info" size="small" plain>退出</el-button>
                    </span>
                </div>
            </div>
        </div>
        <div class="clearfix admin_all">
            <div class="fl admin_left">
                <el-menu
                    :default-active="activePath"
                    class="el-menu-vertical-demo"
                    :unique-opened='true'
                    background-color="#545c64"
                    text-color="#fff"
                    active-text-color="#ffd04b">
                    <router-link to="Notreview">
                        <el-menu-item index="Notreview">
                            <i class="iconfont icon-yonghuguanli" style="margin-right:10px;font-size:18px"></i>
                            <span slot="title">项目评审</span>
                        </el-menu-item>
                    </router-link>
                    <router-link to="Hasassessed">
                        <el-menu-item index="Hasassessed">
                            <i class="iconfont icon-zijinguanli" style="margin-right:10px;font-size:18px"></i>
                            <span slot="title">项目列表</span>
                        </el-menu-item>
                    </router-link>
                    <router-link to="reviewPassword">
                        <el-menu-item index="reviewPassword">
                            <i class="iconfont icon-zhanghaoguanli" style="margin-right:10px;font-size:18px"></i>
                            <span slot="title">修改密码</span>
                        </el-menu-item>
                    </router-link>
                </el-menu>
            </div>
            <div class="fr admin_right">
                <div class="bread_container">
                    <el-breadcrumb class="breadcrumb" separator="/">
                        <el-breadcrumb-item 
                            v-for='(name,index) in $route.meta'
                            :key='index'
                            >
                            {{name}}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="bread_view">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            activePath:'',
        }
    },
    methods: {
        exit(){
            this.$router.push({name:'login'})
        },
        getPath(){
            let currentPath = this.$route
            this.activePath = currentPath.name
            if(this.$route.name=="Reviewdetails"){
                if(this.$route.query.val==1){
                    this.activePath = 'Notreview'
                }else if(this.$route.query.val==2){
                    this.activePath = 'Hasassessed'
                }
            }else{
                this.activePath = currentPath.name
            }
        },
    },
    watch:{
        $route(){
            this.getPath()
        }
    },
    mounted() {
        this.getPath()
    },
}
</script>
<style scoped>
@import './../../assets/css//admin/admin.css';
</style>
<style>
.admin_left .el-menu{
    border-right: none;
}
.admin_left .el-submenu__title i{
    color: #fff;
}
.admin_left .el-menu-item i{
    color: #fff;
}
.admin_left .is-active{
    background: rgb(67, 74, 80)!important;
}
</style>